var parent = require('../../es/array/is-array');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/features/array/is-array.js
// module id = 1011
// module chunks = 0